<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-2" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor001"></a>To my mother, to whom I dedicate everything I do. She lived to see all but the last chapter of this book. Never my best critic, she was always my best reader.</span></p>
<br/>
<br/>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-3" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor002"></a>By the rivers of Babylon, </span></p>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-4" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor003"></a>We sat down and wept </span></p>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-5" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor004"></a>When we remembered Zion.</span></p>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-6" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor005"></a>On the willows there </span></p>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-7" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor006"></a>We hung up our harps.</span></p>
<p class="ORIM-Dedication--Front-Matter- ParaOverride-3" id="_idParaDest-8" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor007"></a>—Psalm 137</span></p>
<div class="_idGenObjectStyleOverride-1">
</div>
</div>
<br/>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-9" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor008"></a>I wonder if I shall fall right through the earth!</span></p>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-10" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor009"></a>How funny it’ll seem to come out among the people that walk with their heads downward! </span></p>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-11" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor010"></a>The Antipathies, I think—</span></p>
<p class="ORIM-Dedication--Front-Matter- ParaOverride-3" id="_idParaDest-12" lang="en-US"><span class="CharOverride-5"><a id="_idTextAnchor011"></a>—Lewis Carroll, </span><span class="CharOverride-6">Alice’s Adventures in Wonderland</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled235.vue?12641cfb